export default __webpack_public_path__ + "static/media/logo-sun.b6b5f20a.png";